/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".heading__title[_ngcontent-%COMP%]{font-size:26px;font-weight:600;font-style:normal;line-height:1.31;color:var(--text-color);text-transform:uppercase;margin:0 0 7px}.heading__subtitle[_ngcontent-%COMP%]{display:block;font-size:16px;font-weight:400;font-stretch:normal;line-height:1.5;letter-spacing:.2px;color:var(--text-color)}"];
export { styles as styles };
